import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.PageNotFound.heading',
    defaultMessage: 'Błąd 404!'
  },
  warning: {
    id: 'views.PageNotFound.warning',
    defaultMessage: 'Podana strona nie istnieje!'
  },
  return: {
    id: 'views.PageNotFound.return',
    defaultMessage: 'wróć na stronę główną'
  }
});



// WEBPACK FOOTER //
// ./src/views/PageNotFound/PageNotFoundView.intl.js